import {
  UserMenu,
  MenuItemLink,
  AppBar,
  Layout,
  Logout,
} from "react-admin";
import { ProfileProvider } from "../pages/profile/Profile";
import SettingsIcon from "@mui/icons-material/Settings";
import { Menu } from "./Menu/Menu";

const MyUserMenu = (props: any) => {
  return (
    <UserMenu {...props}>
      <MenuItemLink
        to="/my-profile"
        primaryText="My Profile"
        leftIcon={<SettingsIcon />}
      />
      <Logout key="logout" />
    </UserMenu>
  );
};

const MyAppBar = (props: any) => {
  return <AppBar {...props} userMenu={<MyUserMenu />} />;
};

const MyLayout = (props: any) => (
  <ProfileProvider>
    <Layout {...props} appBar={MyAppBar} menu={Menu} />
  </ProfileProvider>
);

export default MyLayout;
